import { action as apiAction } from 'api/Api'
import {
  setStatus
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'
import sweetalert from 'sweetalert2'

type Payload = {
  cardId: number
  cardStatusId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId, cardStatusId } = payload

  const optimisticAction = optimisticDispatch(dispatch, setStatus({
    id: cardId,
    statusId: cardStatusId
  }))

  try {
    await apiAction('SetCardStatus', {
      cardId,
      cardStatusId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code === 539) { // Card is blocked
      try {
        await sweetalert({
          text: getState().kanbo.locale.messages['BLOCKERS_CARD_BLOCKED_ERROR'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
